var classes = {"seals":"index-module_seals__N9M-m"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
